import {useTranslation} from '@aboutyou/i18n';
import {
  Collapsible,
  CollapsibleContent,
  COLORS,
  FONT_SIZES,
  GenericIconName,
  Icon,
  tabletAndUp,
  Text,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';

export const HeroElementCollapsibleText: React.FC<{
  className?: string;
  text: string;
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
}> = ({className, text, isOpen, onToggle}) => {
  const handleOnChange = (isOpen: boolean) => {
    onToggle?.(isOpen);
  };

  return (
    <StyledCollapsible
      $isOpen={isOpen}
      className={className}
      onChange={handleOnChange}
      openerContent={<Opener isOpen={isOpen} />}
      bodyContent={text}
      minHeight={process.env.STACK === 'desktop' ? 42 : 40}
    />
  );
};

const Opener: React.FC<{isOpen: boolean}> = ({isOpen}) => {
  const {t} = useTranslation();
  return (
    <OpenerWrapper>
      <Text transform="uppercase" color="White">
        {t('Show more')}
      </Text>
      <Icon
        data-testid="accordionToggleIcon"
        size="XXS"
        fill="White"
        asset={isOpen ? GenericIconName.ArrowUp : GenericIconName.ArrowDown}
      />
    </OpenerWrapper>
  );
};

const OpenerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  cursor: pointer;
`;

const StyledCollapsible = styled(Collapsible)<{$isOpen: boolean}>`
  line-height: 1.5;
  text-align: center;

  ${CollapsibleContent} {
    color: ${COLORS.White};
    font-size: ${FONT_SIZES.px12};
    opacity: 0.8;

    ${({$isOpen}) =>
      $isOpen &&
      css`
        opacity: 1;
      `}

    ${tabletAndUp(
      css`
        font-size: ${FONT_SIZES.px14};
      `,
    )}
  }
`;
